import React from 'react';
import ModalBasic from '../../../pages/component/ModalBasic.js';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import moment from 'moment';
import ValidationText from '../../../utils/validation/ValidationText.js';
import DatePicker from 'react-datepicker';

const ItemDetailsModelForStockCredit = (props) => {
    return (
        <ModalBasic
            id="adding-item-popUp"
            modalOpen={props.setItemDetailsModel}
            setModalOpen={props.setOpenModel}
            title="Item Details"
            noCloseIcon={true}
        >
            <div className="item-form ">
                <div className="form-table">
                    <div className="item-grp !flex !gap-2.5 !mb-2.5">
                        <div className="input-grp w-full">
                            <label>Item Name</label>
                            <MultiSelectDropdown
                                drpIdentity="itemId"
                                options={props.rawMaterialList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                    props.setFilterParametersForItemTable(
                                        selected,
                                        "itemId"
                                    )
                                }
                                allowSelectAll={false}
                                value={props.rawMaterialList.filter(
                                    (party) => party.value === props.itemDetails.itemId
                                )}
                            />
                            <ValidationText error={props.validState.error.itemId} />
                        </div>
                        <div className="input-grp">
                            <label>Batch No</label>
                            <input
                                type="text"
                                id="batchNo"
                                name="batchNo"
                                value={props.itemDetails.batchNo}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "batchNo")
                                }
                                className={`inputFocus`}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Exp Date</label>
                            <DatePicker
                                selected={props.itemDetails.expDate}
                                className={`inputFocus`}
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                onChange={(date) => props.handleChangeForDatePicker(date, "expDate")}
                            />
                        </div>
                        <div className="input-grp">
                            <label>M.R.P</label>
                            <input
                                type="text"
                                id="mrp"
                                name="mrp"
                                value={props.itemDetails.mrp}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "mrp")
                                }
                                className={`inputFocus`}
                            />
                        </div>
                        <div className="input-grp">
                            <label>R.P. Rate</label>
                            <input
                                type="text"
                                id="rpRate"
                                name="rpRate"
                                value={props.itemDetails.rpRate}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "rpRate")
                                }
                                className={`inputFocus`}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Mfgr</label>
                            <input
                                type="text"
                                id="mfgr"
                                name="mfgr"
                                value={props.itemDetails.mfgr}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "mfgr")
                                }
                                className={`inputFocus`}
                            />
                        </div>
                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">

                        <div className="input-grp w-full">
                            <label>Quantity</label>
                            <input
                                type="number"
                                id="qty"
                                name="qty"
                                className="inputFocus"
                                value={props.itemDetails.qty}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "qty")
                                }
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Free</label>
                            <input
                                type="number"
                                id="free"
                                name="free"
                                className="inputFocus"
                                value={props.itemDetails.free}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "free")
                                }
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Rate</label>
                            <input
                                type="number"
                                id="rate"
                                name="rate"
                                className="inputFocus"
                                value={props.itemDetails.rate}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "rate")
                                }
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Amount</label>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                className='inputFocus'
                                value={props.itemDetails.amount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "amount")
                                }
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Other</label>
                            <input
                                type="number"
                                id="other"
                                name="other"
                                className='inputFocus'
                                value={props.itemDetails.other}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "other")
                                }
                            />
                        </div>

                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">
                        <div className="input-grp w-full">
                            <label>HSN Code</label>
                            <input className="inputFocus"
                                type="number"
                                id="hsnCodeName"
                                name="hsnCodeName"
                                value={props.itemDetails.hsnCodeName}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "hsnCodeName")
                                }
                            />
                            <ValidationText error={props.validState.error.hsnCodeName} />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>SGST [%]</label>
                            <input className="inputFocus"
                                type="number"
                                id="sgst"
                                name="sgst"
                                value={props.itemDetails.sgst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "sgst")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>CGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="cgst"
                                name="cgst"
                                value={props.itemDetails.cgst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "cgst")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>IGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="igst"
                                name="igst"
                                value={props.itemDetails.igst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "igst")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>UGST [%]</label>
                            <input className="inputFocus"
                                type="number"
                                id="ugst"
                                name="ugst"
                                value={props.itemDetails.ugst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "ugst")
                                }
                            />
                        </div>
                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">
                        <div className="input-grp w-full">
                            <label>Taxable Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="taxableAmount"
                                name="taxableAmount"
                                value={props.itemDetails.taxableAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "taxableAmount")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>SGST Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="sgstAmount"
                                name="sgstAmount"
                                value={props.itemDetails.sgstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "sgstAmount")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>CGST Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="cgstAmount"
                                name="cgstAmount"
                                value={props.itemDetails.cgstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "cgstAmount")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>IGST Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="igstAmount"
                                name="igstAmount"
                                value={props.itemDetails.igstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "igstAmount")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>UGST Amount</label>
                            <input className="inputFocus"
                                type="number"
                                id="ugstAmount"
                                name="ugstAmount"
                                value={props.itemDetails.ugstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "ugstAmount")
                                }
                            />
                        </div>
                    </div>
                    <div className="btn-grp flex gap-2.5 mt-5">
                        {props.isEditing ?
                            <button
                                className="add-btn"
                                onClick={props.addItemToItemArray}
                            >
                                Save
                            </button> :
                            <button
                                className="add-btn"
                                onClick={props.addItemToItemArray}
                            >
                                Add
                            </button>
                        }

                        <button
                            className="cancel-btn"
                            onClick={props.closePopUp}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
};

export default ItemDetailsModelForStockCredit;